import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import { useSnackbar } from 'notistack';

import { SelectInput } from '../../../Components';
import { getListAllAPI, api, getUserId } from '../../../services';
import {
  AVALIACAO_FEITO_COM_EXCELENCIA,
  AVALIACAO_MALFEITO,
  AVALIACAO_NAO_REALIZADO,
} from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const optionsAvaliacao = [
  {
    label: 'Feito com Execelência',
    value: AVALIACAO_FEITO_COM_EXCELENCIA,
  },
  {
    label: 'Malfeito',
    value: AVALIACAO_MALFEITO,
  },
  {
    label: 'Não Realizado',
    value: AVALIACAO_NAO_REALIZADO,
  },
];

const DEFAULT_ID = -1;

const DialogoCategoriaTransacao = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [avaliacao, setAvaliacao] = useState(AVALIACAO_FEITO_COM_EXCELENCIA);
  const [colaborador, setColaborador] = useState('');
  const [atividade, setAtividade] = useState('');
  const [data, setData] = useState('');
  const [id, setId] = useState(DEFAULT_ID);

  const [carregando, setCarregando] = useState(false);

  const classes = useStyles({ cor: '#009FD4' });

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  function formatData(data) {
    return moment(new Date(data)).format('DD/MM/YYYY');
  }

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'instancias_atividades_processos',
        ['id', 'asc'],
        { id: [id] },
        ['atividade', 'colaborador'],
      );
      if (data.data.length > 0) {
        setId(data.data[0].id);
        setAvaliacao(AVALIACAO_FEITO_COM_EXCELENCIA);
        setColaborador(data.data[0].colaborador.nome);
        setAtividade(data.data[0].atividade.nome);
        setData(formatData(data.data[0].data_entrega));
        setCarregando(false);
      } else {
        throw 'Esta atividade não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  async function handleSalvar() {
    setCarregando(true);
    try {
      const response = await api.put(
        `/instancias_atividades_processos/avaliar/${id}`,
        {
          avaliacao,
          avaliador_id: getUserId(),
        },
      );
      const { status, message } = response.data;

      if (!status) {
        enqueueSnackbar(`${message}`, {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('Atividade Avaliada com sucesso!', {
          variant: 'success',
        });
      }
      setCarregando(false);
      handleCloseDialog();
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen(id) {
      setCarregando(true);
      getDataResource(id);
      setId(id);
      setOpen(true);
    },
  }));

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          Avaliar Atividade
        </DialogTitle>
        <DialogContent
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          {carregando ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div>
              <Box flex={1} mr="0.5em">
                <SelectInput
                  labelId="demo-simple-select-label"
                  name="avaliação"
                  handleEnter={() => {}}
                  label="Avaliação"
                  handleKey={() => {}}
                  value={avaliacao}
                  onChange={(value) => setAvaliacao(value.target.value)}
                  options={optionsAvaliacao}
                  fullWidth
                  style={{
                    marginTop: '20px',
                  }}
                />
              </Box>
            </div>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          <div className={classes.wrapper}>
            <Button
              onClick={handleSalvar}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              variant="contained"
              color="primary"
            >
              Salvar
            </Button>
            {carregando && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
